import { Link } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';
import { firstAllowedHref } from '../components/HomeRedirect';

export function Forbidden() {
  const { can, loading } = usePermissions();
  const homeHref = loading ? '/' : firstAllowedHref(can);

  return (
    <div className="p-8 max-w-lg mx-auto text-center">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Acceso denegado</h1>
      <p className="text-gray-600 mb-6 text-sm">
        No tenés permiso para ver esta sección. Si creés que es un error, contactá a un administrador.
      </p>
      <Link to={homeHref === '/forbidden' ? '/' : homeHref} className="text-blue-700 hover:underline text-sm">
        Volver al inicio
      </Link>
    </div>
  );
}
